//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TreeNode from './TreeNode.vue'
import DraggableNode from './DraggableNode.vue'
import TreeMixin from '../mixins/TreeMixin.js'
import TreeDnd from '../mixins/DndMixin.js'
import Tree from '../lib/Tree.js'

const defaults = {
  direction: 'ltr',
  multiple: true,
  checkbox: false,
  checkOnSelect: false,
  autoCheckChildren: true,
  autoDisableChildren: true,
  checkDisabledChildren: true,
  parentSelect: false,
  keyboardNavigation: true,
  nodeIndent: 24,
  minFetchDelay: 0,
  fetchData: null,
  propertyNames: null,
  deletion: false,
  dnd: false,
  editing: false,
  onFetchError: function(err) { throw err }
}

const filterDefaults = {
  emptyText: 'Nothing found!',
  matcher(query, node) {
    const isMatched = new RegExp(query, 'i').test(node.text)

    if (isMatched) {
      if (node.parent && new RegExp(query, 'i').test(node.parent.text)) {
        return false
      }
    }

    return isMatched
  },
  plainList: false,
  showChildren: true
};

export default {
  name: 'Tree',
  components: {
    TreeNode,
    DraggableNode
  },

  mixins: [TreeMixin, TreeDnd],

  provide: _ => ({
    tree: null
  }),

  props: {
    data: {},

    options: {
      type: Object,
      default: _ => ({})
    },

    filter: String,

    tag: {
      type: String,
      default: 'div'
    }
  },

  watch: {
    filter (term) {
      this.tree.filter(term)
    }
  },

  computed: {
    visibleModel() {
      return this.model.filter(function(node) {
        return node && node.visible()
      }) 
    },

    visibleMatches() {
      return this.matches.filter(function(node) {
        return node && node.visible()
      })
    }
  },

  data () {
    // we should not mutating a prop directly...
    // that's why we have to create a new object
    // TODO: add method for changing options
    let opts = Object.assign({}, defaults, this.options)

    opts.filter = Object.assign(
      {},
      filterDefaults,
      opts.filter
    )

    return {
      model: [],
      tree: null,
      loading: false,
      opts,
      matches: [],
      draggableNode: null
    }
  }
}
